<template>
  <b-modal
      scrollable size="lg"
      :visible="visible"
      no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button
            type="button"
            class="close"
            @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <b-form>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-1"></div>
        <div class="col-8">
          <b-form-group :label-cols="5"
                        label="Template Name"
                        :state="stateForField('name')"
                        :invalid-feedback="errorForField('name')"
                        label-class="text-right"
                        class="mt-2">
            <b-form-input v-model="estimateTemplate.name"></b-form-input>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Diagnostic Codes</h6></div>
          </div>
          <b-form-group
              :label-cols="5"
              id="primaryIcdCmCodeGroup"
              invalid-feedback="Primary ICD-10 code is not valid"
              label="Primary ICD-10 Code"
              label-class="text-right">
            <autocomplete
                ref="primaryIcdAutocomplete"
                :orange-border="false"
                :options="matchedIcdCodes"
                v-model="primaryIcd"
                @input="onInputPrimaryIcdSearch"
                @select="selectPrimaryIcdCode"
                placeholder="Add primary ICD-10 code">
              <template slot-scope="{ option }">
                <div class="content">
                  <p v-if="option">{{ formatICD10(option.code) }}<br>
                    {{ option.description }}</p>
                </div>
              </template>
            </autocomplete>
          </b-form-group>
          <b-form-group
              :label-cols="5"
              id="secondaryIcdCmCodeGroup"
              invalid-feedback="Secondary ICD-10 code is not valid"
              label="Secondary ICD-10 Code"
              label-class="text-right">
            <autocomplete
                ref="secondaryIcdAutocomplete"
                :orange-border="false"
                :options="matchedIcdCodes"
                v-model="secondaryIcd"
                @input="onInputSecondaryIcdSearch"
                @select="selectSecondaryIcdCode"
                placeholder="Add secondary ICD-10 code">
              <template slot-scope="{ option }">
                <div class="content">
                  <p>{{ formatICD10(option.code) }}<br>
                    {{ option.description }}</p>
                </div>
              </template>
            </autocomplete>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Procedure Codes</h6></div>
          </div>
          <b-form-group :label-cols="5"
                        label="Codes"
                        label-class="text-right">
                                <div v-for="line in estimateTemplate.lines" :key="'line-' + line.organizationEstimateTemplateLineId" class="mt-2">
                                 {{ displayCode(line) }}
                                  <font-awesome-icon @click="removeCode(line)" class="mx-1" :icon="['far', 'trash-alt']"/>
                                </div>
              <div v-if="!estimateTemplate.lines ||estimateTemplate.lines.length === 0" class="mt-2">
                No codes added.
              </div>
          </b-form-group>
          <b-form-group
              :label-cols="5"
              id="additionalCodes"
              label="Add Code"
              label-class="text-right">
            <autocomplete :orange-border="false" :options="matchedCodes" v-model="searchTerm" @select="selectCode" placeholder="Add code">
              <template slot-scope="{ option }">
                <div class="content">
                  <p>{{ option.code }}<span v-if="option.modifier">&nbsp; {{ option.modifier }}</span><br>
                    {{ option.description }}</p>
                </div>
              </template>
            </autocomplete>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Additional Professional Fees</h6></div>
          </div>
          <b-form-group :label-cols="5"
                        label="Professional Fees"
                        label-class="text-right">
                              <div v-for="fee in estimateTemplate.fees" :key="fee.organizationEstimateFeeId" class="mt-2">
                                <div v-if="fee.estimateFee">{{ fee.estimateFee.description }}<font-awesome-icon @click="removeFee(fee)" class="mx-1" :icon="['far', 'trash-alt']"/></div>
                                <div v-if="fee.description">{{ fee.description }}<font-awesome-icon @click="removeFee(fee)" class="mx-1" :icon="['far', 'trash-alt']"/></div>
            </div>
            <div class="mt-2" v-if="!estimateTemplate.fees || estimateTemplate.fees.length === 0">
              No fees added.
            </div>
          </b-form-group>
            <b-form-group :label-cols="5"
                          label="Add Professional Fee"
                          :state="stateForField('professionalFee')"
                          :invalid-feedback="errorForField('professionalFee')"
                          label-class="text-right">
              <b-select class="input-border" v-model="selectedFeeOption" :options="feeOptions"
                        @change="addFee"></b-select>
            </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Additional Facility Fees</h6></div>
          </div>
          <b-form-group :label-cols="5"
                        label="Additional Facility Fees"
                        label-class="text-right">
                              <div v-for="ascFee in estimateTemplate.ascFees" :key="ascFee.organizationEstimateAscFeeId" class="mt-2">
                                <div v-if="ascFee.estimateAscFee">{{ascFee.estimateAscFee.description}}<font-awesome-icon @click="removeAscFee(ascFee)" class="mx-1" :icon="['far', 'trash-alt']"/></div>
                                <div v-if="ascFee.description">{{ascFee.description}}<font-awesome-icon @click="removeAscFee(ascFee)" class="mx-1" :icon="['far', 'trash-alt']"/></div>
                              </div>
            <div class="mt-2" v-if="!estimateTemplate.ascFees || estimateTemplate.ascFees.length === 0">
              No fees added.
            </div>
          </b-form-group>
          <b-form-group :label-cols="5"
                        label="Add Additional Facility Fee"
                        :state="stateForField('facilityFee')"
                        :invalid-feedback="errorForField('facilityFee')"
                        label-class="text-right">
            <b-form-select class="input-border" v-model="selectedAscFeeOption"
                      :options="ascFeeOptions"
                      @change="addAscFee"></b-form-select>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Co-Provider Fees</h6></div>
          </div>
          <b-form-group :label-cols="5"
                        label="CoProvider Fees"
                        label-class="text-right">
            <div v-for="coProvider in estimateTemplate.coProviders" :key="coProvider.organizationCoProviderId" class="mt-2">
           {{ formatProviderName(coProvider.coProvider) }}
              <font-awesome-icon @click="removeCoProvider(coProvider)" class="mx-1" :icon="['far', 'trash-alt']"/>
            </div>
            <div class="mt-2" v-if="!estimateTemplate.coProviders || estimateTemplate.coProviders.length === 0">
              No fees added.
            </div>
          </b-form-group>
          <b-form-group :label-cols="5"
                        label="Add CoProvider Fee"
                        :state="stateForField('coProvider')"
                        :invalid-feedback="errorForField('coProvider')"
                        label-class="text-right">
            <b-form-select class="input-border" v-model="selectedCoProviderOption"
                      :options="coProviderOptions"
                      @change="addCoProvider">
            </b-form-select>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Implant</h6></div>
          </div>
          <b-form-group horizontal
                        :label-cols="5"
                        breakpoint="md"
                        :state="stateForField('implantRequired')"
                        :invalid-feedback="errorForField('implantRequired')"
                        label="Implant Required?"
                        label-class="text-right">
            <b-form-radio-group class="pt-2" v-model="estimateTemplate.hasImplant" :options="yesNoOptions"/>
          </b-form-group>
          <b-form-group v-if="estimateTemplate.hasImplant === true" :label-cols="5" label="Implant Description" label-align="right" :state="stateForField('implantDescription')" :invalid-feedback="errorForField('implantDescription')">
            <b-form-input v-model="estimateTemplate.implantDescription"></b-form-input>
          </b-form-group>
          <b-form-group v-if="estimateTemplate.hasImplant === true" :label-cols="5" label="Amount" label-align="right" :state="stateForField('implantAmount')" :invalid-feedback="errorForField('implantAmount')">
            <b-input-group prepend="$">  <b-form-input v-model="estimateTemplate.implantCost"></b-form-input></b-input-group>
          </b-form-group>
          <div class="form-row">
            <div class="col-4"></div>
            <div class="col"><h6 class="text-center mb-3">Surveys</h6></div>
          </div>
          <b-form-group :label-cols="5"
                        label="Survey Set"
                        :state="stateForField('survey')"
                        :invalid-feedback="errorForField('survey')"
                        label-class="text-right">
            <b-dropdown class="text-left"
                        :text="surveySetName"
                        :variant="hasError('providerId') ? 'outline-danger' : 'outline-dark'">
              <b-dropdown-item v-for="survey in estimateTemplateOptions.surveys" :key="survey.organizationEstimateSurveySetId"
                               @click.prevent="setEstimateSurveySet(survey)">{{ survey.name }}
              </b-dropdown-item>
            </b-dropdown>
          </b-form-group>
          </div>
                </div>
              </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange m-1 wide-button float-right" @click.prevent="saveEstimateTemplate()">
        <i class="fa fa-spinner fa-spin"></i> Save Template
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
    </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import Autocomplete from '@/components/Autocomplete.vue'
  import api from '@/services/api'
  import _ from 'lodash'
  export default {
    name: 'EstimateTemplateModal',
    components: { Autocomplete },

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      editEstimateTemplate: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        estimateTemplate: {
          coProviders: [],
          lines: [],
          ascFees: [],
          primaryIcdCmCodeId: null,
          secondaryIcdCmCodeId: null,
          secondaryIcdCmCode: {
            icdCmCodeId: null,
            code: '',
            description: ''
          },
          organizationEstimateSurveySetId: 0,
          organizationEstimateSurveySet: {},
          organizationEstimateTemplateId: null,
          hasImplant: false,
          implantDescription: '',
          implantCost: 0
        },
        secondaryIcd: '',
        items: '',
        selectedSurveySetId: 0,
        primaryIcd: '',
        matchedIcdCodes: [],
        icdSearchTerm: '',
        matchedCodes: [],
        searchTerm: '',
        surveySetName: 'Select survey set',
        selectedCoProviderOption: 0,
        selectedFeeOption: 0,
        selectedAscFeeOption: 0,
        yesNoOptions: [
          { value: false, text: 'No' },
          { value: true, text: 'Yes' }
        ],
        isSaving: false,
        estimateTemplateOptions: {
          fees: [],
          ascFees: [],
          coProviders: [],
          surveys: []
        }
      }
    },
    watch: {
      editEstimateTemplate (newValue) {
        this.clearAllErrors()
        this.clearData()
        this.estimateTemplate = _.clone(newValue)
        if (this.estimateTemplate.organizationEstimateSurveySetId > 0) {
          this.surveySetName = this.estimateTemplate.organizationEstimateSurveySet.name
        } else {
          this.surveySetName = 'Select survey set'
        }
        if (this.estimateTemplate?.primaryIcdCmCode?.code) {
          this.$nextTick(() => {
            this.primaryIcd = this.formatICD10(this.estimateTemplate.primaryIcdCmCode.code)
          })
        }
        if (this.estimateTemplate?.secondaryIcdCmCode?.code) {
          this.$nextTick(() => {
            this.secondaryIcd = this.formatICD10(this.estimateTemplate.secondaryIcdCmCode.code)
          })
        }
      },
      searchTerm: _.debounce(function (searchTerm) {
        this.searchCodes()
      }, 500)
    },
    computed: {
      title () {
        if (this.estimateTemplate.organizationEstimateTemplateId > 0) {
          return 'Edit Estimate Template'
        }
        return 'Create Estimate Template'
      },
      feeOptions () {
        const options = [{
          text: 'Select professional fee',
          value: 0
        }]
        this.estimateTemplateOptions.fees.forEach(option => {
          options.push({
            text: option.description,
            value: option.organizationEstimateFeeId
          })
        })
        return options
      },
      ascFeeOptions () {
        const options = [{
          text: 'Select facility fee',
          value: 0
        }]
        this.estimateTemplateOptions.ascFees.forEach(option => {
          options.push({
            text: option.description,
            value: option.organizationEstimateAscFeeId
          })
        })
        return options
      },
      coProviderOptions () {
        const options = [{
          text: 'Select coprovider fee',
          value: 0
        }]
        this.estimateTemplateOptions.coProviders.forEach(option => {
          options.push({
            text: this.formatProviderName(option),
            value: option.organizationCoProviderId
          })
        })
        return options
      }
    },

    methods: {
      clearData () {
        this.estimateTemplate = {}
        this.primaryIcd = ''
        this.secondaryIcd = ''
        this.selectedAscFeeOption = 0
        this.selectedFeeOption = 0
        this.selectedCoProviderOption = 0
      },
      onInputPrimaryIcdSearch (primaryIcd) {
        this.icdSearchTerm = primaryIcd
        this.searchIcdCodes()
      },

      onInputSecondaryIcdSearch (secondaryIcd) {
        this.icdSearchTerm = secondaryIcd
        this.searchIcdCodes()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },
      searchCodes () {
        if (!this.searchTerm) {
          this.matchedCodes = []
          return
        }

        const parameters = {
          searchTerm: this.searchTerm
        }

        api.post('/Dashboard/CodeSearch', parameters).then(response => {

          this.matchedCodes = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search for code: ' + error.message, error)
          }
        })
      },
      selectCode (code) {
        this.searchTerm = ''
        if (!this.estimateTemplate.lines) {
          this.estimateTemplate.lines = []
        }
        this.estimateTemplate.lines.push({
          code: code.code,
          description: code.description,
          modifier: code.modifier ? code.modifier : null
        })
      },
      removeCode (line) {
        this.estimateTemplate.lines = this.estimateTemplate.lines.filter((aLine) => {
          return !(aLine.code === line.code && aLine.modifier === line.modifier)
        })
      },
      removeFee (fee) {
        this.estimateTemplate.fees = this.estimateTemplate.fees.filter((aFee) => {
          const feeDescriptionToRemove = fee.estimateFee
            ? fee.estimateFee.description
            : fee.description
          const feeDescriptionInList = aFee.estimateFee
            ? aFee.estimateFee.description
            : aFee.description
          return feeDescriptionInList !== feeDescriptionToRemove
        })
      },
      removeAscFee (ascFee) {
        this.estimateTemplate.ascFees = this.estimateTemplate.ascFees.filter((aAscFee) => {
          const ascDescriptionToRemove = ascFee.estimateAscFee
            ? ascFee.estimateAscFee.description
            : ascFee.description
          const ascDescriptionInList = aAscFee.estimateAscFee
            ? aAscFee.estimateAscFee.description
            : aAscFee.description
          return ascDescriptionInList !== ascDescriptionToRemove
        })
      },
      removeCoProvider (coProvider) {
        this.estimateTemplate.coProviders = this.estimateTemplate.coProviders.filter((aCoProvider) => {
          return !(aCoProvider.coProvider.lastName === coProvider.coProvider.lastName)
        })
      },
      searchIcdCodes () {
        if (!this.icdSearchTerm) {
          this.matchedIcdCodes = []
          return
        }
        const parameters = {
          searchTerm: this.icdSearchTerm.replace(/[\s.]+/g, '')
        }
        api.post('/Dashboard/IcdCodeSearch', parameters).then(response => {
          this.matchedIcdCodes = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search for ICD10 code: ' + error.message, error)
          }
        })
      },
      selectPrimaryIcdCode (code) {
        this.icdSearchTerm = ''
        this.matchedIcdCodes = []
        // work around for value not updating properly in autocomplete component
        this.primaryIcd = this.formatICD10(code.code)
        this.estimateTemplate.primaryIcdCmCodeId = code.icdCmCodeId
        this.estimateTemplate.primaryIcdCmCode = code
      },
      selectSecondaryIcdCode (code) {
        this.icdSearchTerm = ''
        this.matchedIcdCodes = []
        // work around for value not updating properly in autocomplete component
        this.secondaryIcd = this.formatICD10(code.code)
        this.estimateTemplate.secondaryIcdCmCodeId = code.icdCmCodeId
        this.estimateTemplate.secondaryIcdCmCode = code
      },
      formatICD10 (code) {
        if (code.length > 6) {
          return code.substr(0, 3) + '.' + code.substr(3, 3) + '.' + code.substr(6)
        } else if (code.length > 3) {
          return code.substr(0, 3) + '.' + code.substr(3)
        }
        return code
      },
      addFee (feeId) {
        if (!this.estimateTemplate.fees) {
          this.$set(this.estimateTemplate, 'fees', [])
        }
        const fee = this.estimateTemplateOptions.fees.find(aFee => aFee.organizationEstimateFeeId === feeId)
        if (fee) {
          this.estimateTemplate.fees.push({
            estimateFee: fee,
            organizationEstimateFeeId: feeId
          })
        }
      },
      addAscFee (ascFeeId) {
        if (!this.estimateTemplate.ascFees) {
          this.$set(this.estimateTemplate, 'ascFees', [])
        }
        const ascFee = this.estimateTemplateOptions.ascFees.find(anAscFee => anAscFee.organizationEstimateAscFeeId === ascFeeId)
        if (ascFee) {
          this.estimateTemplate.ascFees.push({
            organizationEstimateAscFeeId: ascFeeId,
            estimateAscFee: ascFee
          })
        }
      },
      addCoProvider (coProviderId) {
        if (!this.estimateTemplate.coProviders) {
          this.$set(this.estimateTemplate, 'coProviders', [])
        }
        const coProvider = this.estimateTemplateOptions.coProviders.find(aCoProvider => aCoProvider.organizationCoProviderId === coProviderId)
        if (coProvider) {
          this.estimateTemplate.coProviders.push({
            coProvider,
            organizationCoProviderId: coProviderId
          })
        }
      },
      setEstimateSurveySet (survey) {
        this.estimateTemplate.organizationEstimateSurveySetId = survey.organizationEstimateSurveySetId
        this.surveySetName = survey.name
      },
      loadEstimateTemplateOptions () {
        api.get('Dashboard/EstimateTemplateOptions').then(response => {
          this.estimateTemplateOptions = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load code survey sets: ' + error.message, error)
          }
        })
      },
      formatProviderName (coProvider) {
        let name = coProvider.facilityName
        if (coProvider.lastName) {
          name += ' - ' + coProvider.lastName
          if (coProvider.firstName) {
            name += ', ' + coProvider.firstName
          }
        }
        return name
      },
      displayCode (code) {
        let codeDisplay = code.code
        if (code.modifier) {
          codeDisplay = codeDisplay + ' ' + code.modifier
        }

        if (code.description) {
          codeDisplay = codeDisplay + ' - ' + code.description
        }

        return codeDisplay
      },
      saveEstimateTemplate () {
        if (this.isSaving === true) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        this.isSaving = true
        let urlSuffix = ''
        if (this.estimateTemplate.organizationEstimateTemplateId) {
          urlSuffix = '/' + this.estimateTemplate.organizationEstimateTemplateId
        }
        api.post('Dashboard/EstimateTemplate' + urlSuffix, this.estimateTemplate).then(response => {
          this.$emit('updated', response.data)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },
      validate () {
        this.clearAllErrors()

        if (!this.estimateTemplate.name) {
          this.addErrorForField('name', 'You must add a template name.')
        }

        if (this.estimateTemplate.hasImplant === null) {
          this.addErrorForField('implantRequired', 'You must select an implant option.')
        }

        if (this.estimateTemplate.hasImplant === true && !this.estimateTemplate.implantDescription) {
          this.addErrorForField('implantDescription', 'You must add an implant description')
        }

        if (this.estimateTemplate.hasImplant === true && !this.estimateTemplate.implantCost) {
          this.addErrorForField('implantAmount', 'You must add an implant cost')
        }

        return !this.hasErrors()
      }
    },
    created () {
      this.loadEstimateTemplateOptions()
    }

  }

</script>

<style scoped>
.autocomplete-input {
  margin-bottom: 0 !important;
}
</style>
